import { Modal, Fade, Box } from "@mui/material";
import React from "react";

const Dialog = ({ isOpen, closeModalClick, children, ...props }: any) => (
	<Modal
		aria-labelledby="transition-modal-title"
		aria-describedby="transition-modal-description"
		open={isOpen}
		onClose={closeModalClick}
		closeAfterTransition
	>
		<Fade in={isOpen}>
			<Box
				sx={{
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					bgcolor: "background.paper",
					width: props.width || "400px",
					height: props.height || 'auto',
					overflow:'auto',
					borderRadius: "4px",
				}}
			>
				{children}
			</Box>
		</Fade>
	</Modal>
);

export default Dialog;
